var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { headlineTheme } from './theme';
export var TestIds;
(function (TestIds) {
    TestIds["headlineComponent"] = "headline__component";
    TestIds["headlineComponentWithSpacer"] = "headline__componentWithSpacer";
})(TestIds || (TestIds = {}));
export var BaseHeadline = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  ", "\n  font-weight: ", ";\n  line-height: ", ";\n  text-align: ", ";\n  letter-spacing: ", ";\n  text-transform: ", ";\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  font-size: ", ";\n  ", "\n  font-weight: ", ";\n  line-height: ", ";\n  text-align: ", ";\n  letter-spacing: ", ";\n  text-transform: ", ";\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].color;
}, function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].fontSize.mobile;
}, function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].font;
}, function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].fontWeight;
}, function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].lineHeight.mobile;
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign;
}, function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].letterSpacing;
}, function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].textTransform;
}, function (_a) {
    var theme = _a.theme;
    return theme.global.breakpoints.tablet;
}, function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].fontSize.tablet;
}, function (_a) {
    var theme = _a.theme, level = _a.level;
    return theme.component.headline[level].lineHeight.tablet;
}, function (_a) {
    var theme = _a.theme, spacer = _a.spacer, textAlign = _a.textAlign;
    return spacer &&
        "\n      &::after {\n        content: '';\n        width: " + theme.component.headline.spacer.size[spacer] + ";\n        border-bottom: 0.125rem solid " + theme.component.headline.spacer.color + ";\n        display: block;\n        margin-top: " + theme.global.spacer.small + ";\n        margin-bottom: " + theme.global.spacer.small + ";\n        margin-left: " + (textAlign === 'center' || textAlign === 'right' ? 'auto' : '0') + ";\n        margin-right: " + (textAlign === 'center' || textAlign === 'left' ? 'auto' : '0') + ";\n    };\n  }";
});
export var SubHeadline = styled(BaseHeadline)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  text-transform: none;\n"], ["\n  color: ", ";\n  text-transform: none;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.headline.subheadline.color;
});
export var Headline = function (_a) {
    var children = _a.children, className = _a.className, level = _a.level, element = _a.element, stylingLevel = _a.stylingLevel, textAlign = _a.textAlign, spacer = _a.spacer, _b = _a.isSubHeadline, isSubHeadline = _b === void 0 ? false : _b;
    var renderedElement = element || "h" + level;
    var appliedLevel = stylingLevel || level;
    var elementProps = element
        ? {
            'aria-level': level,
            role: 'heading',
        }
        : {};
    var HeadlineWrapper = isSubHeadline ? SubHeadline : BaseHeadline;
    var testId = spacer ? TestIds.headlineComponentWithSpacer : TestIds.headlineComponent;
    return (React.createElement(ThemeProvider, { theme: headlineTheme },
        React.createElement(HeadlineWrapper, __assign({ "data-testid": testId, as: renderedElement, level: appliedLevel, textAlign: textAlign, className: className, spacer: spacer }, elementProps), children)));
};
export default Headline;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map